/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignLeft = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M15 12H3" }],
    ["path", { d: "M17 18H3" }],
    ["path", { d: "M21 6H3" }]
  ]
];

export { AlignLeft as default };
//# sourceMappingURL=align-left.js.map
